const getEntryTypeId = entry => entry?.sys?.contentType?.sys?.id;
export { getEntryTypeId };
//# sourceMappingURL=getEntryTypeId.js.map
